"use client";
import React from "react";
import { useTranslations } from "next-intl";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";

const GetLatestPrice = ({ children }: { children: React.ReactNode }) => {
	const { openModalInquiry } = useModalInquiryContext();

	return <div onClick={openModalInquiry}>{children}</div>;
};

export default GetLatestPrice;
